import { useMutation, useQuery, useQueryClient, UseQueryOptions, UseQueryResult } from 'react-query'
import { EquipmentApi } from '@trybeapp/sdk.shop'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { usePageQueryParam } from 'hooks/UsePageQueryParam'

const api = new EquipmentApi()

export const usePagedEquipment = (
  params: any = {},
  options: UseQueryOptions = {}
): UseQueryResult<any> => {
  const [page] = usePageQueryParam()

  return useEquipment({ page, ...params }, options)
}

export const useEquipment = (params: any = {}, options: UseQueryOptions = {}) => {
  const siteId = useCurrentSiteId()

  return useQuery(
    ['equipment', siteId, params],
    () => api.equipmentIndex({ ...params, siteId }),
    options
  )
}

export const useGetEquipment = (equipmentId) => {
  return useQuery(['equipment', equipmentId], async () => await api.equipmentShow(equipmentId))
}

export const useCreateEquipment = () => {
  const queryClient = useQueryClient()
  const siteId = useCurrentSiteId()

  return useMutation((equipment: any) => api.equipmentStore({ ...equipment, site_id: siteId }), {
    onSuccess: () => {
      queryClient.invalidateQueries('equipment')
    },
  })
}

export const useUpdateEquipment = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ([equipmentId, equipment]: any) => api.equipmentUpdate(equipmentId, equipment),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('equipment')
      },
    }
  )
}

export const useCopyEquipment = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ([copyFromId, equipment]: any) => api.equipmentCopy(copyFromId, { equipment }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('equipment')
      },
    }
  )
}

export const useDeleteEquipment = () => {
  const queryClient = useQueryClient()

  return useMutation((equipmentId: string) => api.equipmentDestroy(equipmentId), {
    onSuccess: () => {
      queryClient.invalidateQueries('equipment')
    },
  })
}
